(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('flyerDetailVariations', {
            templateUrl: 'app/admin/flyers/flyer-detail/details-panel/variations/flyer-detail-variations.html',
            controller: flyerDetailVariationsController,
            bindings: {
                flyer: '<',
                isImmoContext: '<'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function flyerDetailVariationsController($translate, StoreService, $localStorage) {
        var vm = this;

        var AVAILABLE_STATUS = 'available';
        var RESERVED_STATUS = 'reserved';
        var SOLD_STATUS = 'sold';
        var DEFAULT_CURRENCY = 'REAL';

        vm.$onInit = init;

        function init() {
            vm.dateFormat = $translate.instant('dotDateFormat');
            vm.updatedDate = vm.flyer.updatedAt ? moment(vm.flyer.updatedAt).format(vm.dateFormat) : "-";
            vm.emptyMessage = $translate.instant(vm.getTranslateKey('flyers.detail-modal.detail-variations.empty-variations'),
                {flyerType: vm.isImmoContext ?
                        $translate.instant('flyers.detail-modal.real-estate').toLowerCase() :
                        $translate.instant('flyers.detail-modal.product').toLowerCase() });

            loadStoreData();

            vm.availableDetailsCount = vm.flyer.details
                ? vm.flyer.details.filter(function (detail) {
                    return detail.status === AVAILABLE_STATUS;
                }).length
                : 0;

            vm.inStock = vm.flyer.details && vm.flyer.details.some(function (detail) {
                return detail.inventory === null;
            }) ? $translate.instant('global.form.unlimited') : vm.flyer.details.reduce(function (total, detail) {
                return total + (detail.inventory ? detail.inventory : 0);
            }, 0);

            vm.originalDetails = vm.flyer.details ? angular.copy(vm.flyer.details) : [];
        }

        function loadStoreData() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
                if (response) {
                    loadCurrencyPrefix(response.data);
                }
            })
        }

        function loadCurrencyPrefix(store) {
            var key = store.currency ? store.currency : DEFAULT_CURRENCY;
            vm.currencyConfigurations = getCurrencyListConfiguration()[key];
        }

        vm.getTranslateKey = function (baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        };

        vm.formatMoney = function (value) {
            if (!vm.currencyConfigurations) {
                return
            }
            return formatMoney(value, vm.currencyConfigurations.prefix, vm.currencyConfigurations.decimalQuant,
                vm.currencyConfigurations.centsSeparator, vm.currencyConfigurations.thousandsSeparator);
        };

        vm.getStatusInfo = function (detail) {
            if (detail.status === SOLD_STATUS) {
                return {class: 'status-sold', text: $translate.instant('flyers.status.sold')};
            } else if (detail.status === RESERVED_STATUS) {
                return {class: 'status-reserved', text: $translate.instant('flyers.status.reserved')};
            } else if (detail.status === AVAILABLE_STATUS) {
                return {class: 'status-available', text: vm.formatMoney(detail.purchaseValue)};
            }
            return {class: '', text: ''};
        };

        vm.statusSorted = false;

        vm.sortByStatusPriority = function () {
            if (!vm.flyer.details) return;

            if (!vm.statusSorted) {
                var statusOrder = {
                    'available': 0,
                    'reserved': 1,
                    'sold': 2
                };

                vm.flyer.details.sort(function (a, b) {
                    return statusOrder[a.status] - statusOrder[b.status];
                });

                vm.statusSorted = true;
            } else {
                vm.flyer.details = angular.copy(vm.originalDetails);
                vm.statusSorted = false;
            }
        };

        vm.getPriceValue = function (detail) {
            if (!detail.discountedValue) {
                return vm.formatMoney(detail.purchaseValue);
            } else {
                var fromText = $translate.instant('flyers.detail-modal.detail-variations.table.price.from');
                return fromText + " " + vm.formatMoney(detail.purchaseValue);
            }
        };

        vm.getDiscountedValue = function (detail) {
            var toText = $translate.instant('flyers.detail-modal.detail-variations.table.price.to');
            return toText + " " + vm.formatMoney(detail.discountedValue);
        };

        vm.truncateText = function (text, size) {
            return truncateText(text, size);
        }
    }
})();
